import room from "../../assets/room.png"

export default function RoomBackground() {
  return (
    <img src={room} className="room-bg" alt="Room background"/>
  )
}